<template>
  <div class="privacy">
    <header class="header">

      <section class="menu clearfix">
        <div class="logo">
          <img src="../assets/lp/logo.png" alt="ikude">
        </div>

        <div class="controller">
          <nav>
            <ul class="lp-nav">
              <li><a href="/">TOP</a></li>
            </ul>
          </nav>

        </div>
      </section>

    </header>
    <section class="intro">

      <p>
        Goldrush Computing株式会社（以下「当社」といいます。）は、当社の提供する位置情報サービス「ikude」（以下「本サービス」といいます。）におけるお客様（以下「ユーザー」といいます。）についての個人情報を含む利用者情報の取り扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。
      </p>


    </section>

    <section class="method">

      <h1>１　収集する利用者情報及び収集方法</h1>

      <p>本ポリシーにおいて、「利用者情報」とは、ユーザーの識別に係る情報、通信サービス上の行動履歴、その他ユーザーのiPhone、iPad、Androidスマートフォン等の情報端末（以下「スマートフォン等」といいます。）においてユーザー又はユーザーの端末に関連して生成又は蓄積された情報であって、本ポリシーにもとづき当社が収集するものを意味するものとします。本サービスにおいて、当社が収集する利用者情報は、その収集方法に応じて、以下のようなものとなります。</p>

      <h2>(1) 本サービスの導入企業から収集する情報</h2>
      <ul>
        <li>氏名</li>
        <li>電話番号</li>
        <li>メールアドレス</li>
        <li>住所（配達・送迎先）</li>
      </ul>
      <p>※本サービスを商品等の配達に利用する場合、次の情報も収集いたします。</p>
      <ul>
        <li>送り主の氏名</li>
        <li>送り主の住所</li>
        <li>送り主の電話番号</li>
        <li>送り主のメールアドレス</li>
        <li>送り主が配達を依頼した物</li>
      </ul>

      <h2>(2) ユーザーが本サービスを利用するにあたって、当社が収集する情報</h2>
      <p>当社は、ユーザーが本サービスを利用する際に、以下の情報を収集することがあります。</p>
      <ul>
        <li>端末情報</li>
        <li>ログ情報及び行動履歴情報</li>
        <li>位置情報</li>
        <li>Cookie及び匿名ID</li>
      </ul>
    </section>

    <section class="purpose">

      <h1>２　利用目的</h1>

      <p>当社は、本サービスの利用を通じて取得したユーザー情報を、下記の目的の範囲内で適正に取り扱います。ユーザーの同意なく利用目的の範囲を超えて利用することはありません。
      </p>

      <table>

        <colgroup>
          <col class="col_1" />
          <col class="col_2" />
        </colgroup>

        <thead>

        <tr>
          <th>利用目的</th>
          <th>利用する情報</th>

        </tr>
        </thead>

        <tbody>
        <tr>
          <td>(1) 本サービスの提供・維持・改善</td>
          <td>
            <ul>
              <li>氏名</li>
              <li>電話番号</li>
              <li>メールアドレス</li>
              <li>住所（配達・送迎先）</li>
              <li>位置情報</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>(2) ユーザーへの通知・対応等</td>
          <td>
            <ul>
              <li>氏名</li>
              <li>電話番号</li>
              <li>メールアドレス</li>
              <li>住所（配達・送迎先）</li>
              <li>位置情報</li>
              <li>送り主の氏名</li>
              <li>送り主の住所</li>
              <li>送り主の電話番号</li>
              <li>送り主のメールアドレス</li>
              <li>送り主が配達を依頼した物</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>(3) 統計データの作成及び当該データの第三者への提供</td>
          <td>
            <ul>
              <li>住所（配達・送迎先）</li>
              <li>端末情報</li>
              <li>ログ情報及び行動履歴情報</li>
              <li>位置情報</li>
              <li>Cookie及び匿名ID</li>
            </ul>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <!--
        <td colspan="1" align="left">
          <strong>Total Number:</strong>
        </td>
        <td>{{ orders.length }}</td>
        -->
        </tfoot>
      </table>
    </section>

    <section class="thirdparty">

      <h1>３　第三者提供</h1>

      <p><span class="section_number">３－１</span>　当社は、利用者情報のうち、個人情報については、個人情報保護法その他の法令にもとづき開示が認められる場合を除くほか、あらかじめユーザーの同意を得ないで、第三者に提供しません。但し、次に掲げる場合はこの限りではありません。
      </p>

      <ol>
        <li>当社が利用目的の達成に必要な範囲内において個人情報の取り扱いの全部又は一部を委託する場合</li>
        <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
        <li>国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザーの同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合</li>
        <li>その他、個人情報保護法その他の法令で認められる場合</li>
      </ol>

      <p><span class="section_number">３－２</span>　当社は、本サービスと提携するサービス（以下「提携サービス」といいます。）を提供する事業者（以下「提携パートナー」といいます。）に対し、ユーザーに提携サービスを提供するため、ユーザーの同意を得た上、個人情報を含むユーザー情報を提供することができるものとします。</p>

    </section>

    <section class="outsource">
      <h1>４　個人情報の取り扱いの委託</h1>
      <p>当社は、ユーザーから取得した個人情報の全部又は一部の取り扱いを第三者に委託することがあります。この場合、当社は、当該委託先との間で本ポリシーに準じる内容の秘密保持契約等をあらかじめ締結するとともに、当該委託先において情報の適切な安全管理が図られるよう、必要かつ適切な監督を行います。</p>
    </section>

    <section class="share">
      <h1>５　共同利用</h1>
      <p>当社は、提携パートナーとの間で、提携サービスの提供に必要な範囲において、ユーザーの個人情報を共同利用することがあります。この場合、当社は、あらかじめ、提携パートナーの名称、共同利用目的、共同利用する情報の種類を公表するものとします。</p>
    </section>

    <section class="disclosure">
      <h1>６　個人情報の開示</h1>
      <p>当社は、ユーザーから個人情報保護法の定めにもとづき個人情報の開示を求められたときは、ユーザーご本人からの請求であることを確認の上で、ユーザーに対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（１件あたり1000円）を頂戴しておりますので、あらかじめご了承ください。</p>
    </section>

    <section class="termination">
      <h1>７　個人情報の訂正及び利用停止等</h1>
      <p><span class="section_number">７－１</span>　当社は、ユーザーから(1)個人情報が真実でないという理由によって個人情報保護法の定めにもとづきその内容の訂正を求められた場合、及び(2)あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により収集されたものであるという理由により、個人情報保護法の定めにもとづきその利用の停止を求められた場合には、ユーザーご本人からのご請求であることを確認の上で遅滞なく必要な調査を行い、その結果にもとづき、個人情報の内容の訂正又は利用停止を行い、その旨をユーザーに通知します。なお、合理的な理由にもとづいて訂正又は利用停止を行わない旨の決定をしたときは、ユーザーに対しその旨を通知いたします。</p>
      <p><span class="section_number">７－２</span>　当社は、ユーザーから、ユーザーの個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、ユーザーご本人からのご請求であることを確認の上で、個人情報の消去を行い、その旨をユーザーに通知します。</p>
      <p><span class="section_number">７－３</span>　個人情報保護法その他の法令により、当社が訂正等又は利用停止等の義務を負わない場合は、前２項の規定は適用されません。</p>
    </section>

    <section class="contact">
      <h1>８　お問い合わせ窓口</h1>
      <p>ご意見、ご質問、苦情のお申出その他利用者情報の取り扱いに関するお問い合わせは、下記の窓口までお願いいたします。</p>
      <p>住所：東京都渋谷区神宮前1-2-14 幸進ビル3F</p>
      <p>Goldrush Computing株式会社　　担当：水鳥敬満</p>
      <p>E-mail：mizutori@goldrushcomputing.com</p>
    </section>

    <section class="modification">
      <h1>９　プライバシーポリシーの変更手続き</h1>
      <p>当社は、利用者情報の取り扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本ポリシーを変更することがあります。変更した場合には、当社の運営するウェブサイトでの掲示その他わかりやすい方法によりユーザーに告知いたします。但し、法令上ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法でユーザーの同意を得るものとします。</p>
    </section>

    <footer class="footer">
      <p class="copy">copyright © Goldrush Computing Inc. All Rights Reserved.</p>

    </footer>
  </div>
</template>

<script>


  import * as VueGoogleMaps from "vue2-google-maps";


  export default {
    name: 'LandingPage',

    components: {},

    data() {
      return {}
    },

    computed: {},

    methods: {
      goHome() {
        this.$router.push({name: 'Home'})
      },
    },

    mounted() {




    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  *, *::before, *::after {
    box-sizing: border-box;
  }

  .privacy {
    color: #707070;
    text-align: left;
    font-size: 14px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
  }

  h1 {
    font-size: 18px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
  }

  h2 {
    margin-top: 20px;
    font-size: 14px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
  }

  section {
    margin-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .menu {
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
  }

  section ul {
    padding-left: 20px;
  }

  .section_number {
    font-weight: bold;
  }

  table{
    width: 100%;
    margin-top: 39px;
    border-collapse: collapse;
    font-size: 12px;
  }

  tbody {
    background-color: white;
  }

  table td, table th {
    border: 1px solid #D2D2D2;
    padding: 8px 4px 8px 4px;
  }

  table th{
    background-color: #FAFAFA;
  }

  /*table td:nth-child(3) { width: 190px; }*/

  .td_second_section_header {
    margin-top: 20px;
  }


  ::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }

  header {
    width: 100%;
    height: 50px;
    margin: 0 auto;
    padding: 0;
    background-color: #fff;
    /*border-bottom: 1px solid #D6B000;*/

  }


  .logo {
    float: left;
    padding: 0 0 0 0;
  }


  .logo {
    float: left;
    padding: 0 0 0 0;
  }

  .logo img{
    position: absolute;
    margin: -8px 0 0 0;
    width: 128px;
    height: auto;
  }


  /* ナビゲーションエリア */
  .controller {
    float: right;
    margin-top: 14px;
    margin-bottom: 10px;
  }



  /* ナビゲーション */
  .lp-nav {
    float: right;
    margin: 0 20px 0 0;
  }

  .lp-nav li{
    float: left;
    margin: 0 30px 0 0;
    font-size: 18px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: bold;
    list-style: none;
  }

  .lp-nav li a {
    color: #707070;
  }

  .lp-nav li a:hover {
    border-bottom: 2px solid #ffffff;
    padding-bottom: 3px;
    text-decoration: none;
    color: #D2FF00  ;
  }



  .clearfix::after {
    content: '';
    display: block;
    clear: both;
  }


  .footer {
    margin-top: 0;
    background-color: #F1F1F1;
    color: #707070
  }

  .copy {
    padding: 0;
    font-size: 14px;
  }

  .col_1 {
    width: 50%;
  }

  .col_2 {
    width: 50%;
  }




</style>



// WEBPACK FOOTER //
// src/pages/Privacy.vue